<template>
	<div>
		<div id="openModal" :class="modalClass">
			<div v-if="this.setDetailOrder_status == 'idle'">
				<!-- <a title="Close" class="close">X</a> -->
				<div class="row">
					<div class="col-12 mt-3 text-center" style="color: gold;">
						<big>{{name}}</big>
					</div>
				</div>

				<hr style="background-color: gray;">

				<div class="row" :style="{display: displayFormEdit}">
					<div class="container rounded text-left value-field mb-0 pb-0">
						<div class="col-12">
							<div class="mb-3">
								<span class="text-left">Account</span>
								<div class="text-right float-right text-white">{{account}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Direction</span>
								<div class="text-right float-right text-uppercase font-weight-bold" :style="{color: (direction_prop == 'sell') ? 'red' : 'green'}">{{direction_prop}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Valid Until</span>
								<div class="text-right float-right text-white">{{validUntil_prop}}</div>
							</div>
							
							<div class="mb-3">
								<span class="text-left">Original Quantity</span>
								<div class="text-right float-right text-white number-font">{{quantity}}</div>
							</div>
							<div class="mb-3">
								<span class="text-left">Original Price Per Gram</span>
								<div class="text-right float-right text-white number-font">{{ (currency == 'idr')? 'Rp' : '$' }} {{numberFormat(pricePerGram)}}</div>
							</div>
							<div class="mb-3">
								<span class="text-left">Original Contract Price</span>
								<div class="text-right float-right text-white number-font">{{ (currency == 'idr')? 'Rp' : '$' }} {{numberFormat(contractPrice)}}</div>
							</div>

						</div>

						<hr style="background-color: gray;">

						<div class="container rounded text-left value-field ">

							<div v-if="validity_prop == 'GTD'" class="mb-3">
								<span class="text-left">Expire Date</span>
								<input type="datetime-local" name="" class="float-right rounded c-input c-date-picker" v-model="limitOrderDate" :min="minExpiryDateInInput" onkeydown="return false">
							</div>

							<div class="mb-3" style="line-height: 26px;">
								<span class="text-left">Quantity</span>
								<div class="float-right c-input-field">
									<button class="button button-counter decrease" @click="decreaseQuantityIntEdit()">-</button>
									<input ref="quantityMarket" class="c-input number-font text-white c-hide-spinner" type="number" name="" v-model.number="quantityIntEditInInput">
									<button class="button-counter increase" @click="increaseQuantityIntEdit()">+</button>
								</div>
							</div>
							
							<div v-if="(this.$store.getters.contractConfigByContractId(contractId_prop) || {}).hasQuantityDecimal" class="mb-3" style="line-height: 26px;">
								<span class="text-left" style="color: transparent;">-</span>
								<div class="float-right c-input-field">
									<button class="button button-counter decrease" @click="decreaseQuantityDecimalEdit()">-</button>
									<input ref="quantityMarket" class="c-input number-font text-white c-hide-spinner" type="text" name="" v-model.number="quantityDecimalEditInInput">
									<button class="button-counter increase" @click="increaseQuantityDecimalEdit()">+</button>
								</div>
							</div>

							<div v-if="(this.$store.getters.contractConfigByContractId(contractId_prop) || {}).hasQuantityDecimal" class="mb-3">
								<span class="text-left">Total Quantity</span>
								<div class="text-right float-right text-white">{{ quantityEdit }}</div>
							</div>

							<div class="mb-3" style="line-height: 26px;">
								<span class="text-left">Price Gram</span>
								<div class="float-right c-input-field">
									<button class="button button-counter decrease" @click="decreasePricePerGramEdit()">-</button>
									<input class="c-input number-font text-white c-hide-spinner" type="text" name="" v-model.number="pricePerGramEditInInput">
									<button class="button-counter increase" @click="increasePricePerGramEdit()">+</button>
								</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Contract Price</span>
								<div class="text-right float-right text-white number-font">{{ (currency == 'idr')? 'Rp' : '$' }} {{contractPriceEdit}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Contract Value</span>
								<div class="text-right float-right text-white">{{ (currency == 'idr')? 'Rp' : '$' }} {{contractValueEditShown}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Fee <span class="text-gold number-font">/1%</span></span>
								<div class="text-right float-right text-white number-font">{{ (currency == 'idr')? 'Rp' : '$' }} {{feeEditShown}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Tax <span class="text-gold number-font">/0.1%</span></span>
								<div class="text-right float-right text-white number-font">{{ (currency == 'idr')? 'Rp' : '$' }} {{taxEditShown}}</div>
							</div>

							<div>
								<span class="text-left" style="font-size: 16px;">Total</span>
								<div class="text-right float-right number-font total-value">$ {{totalUsdLimitEditShown}}</div>
								<div class="text-right number-font total-value total-value-idr">Rp {{totalIdrLimitEditShown }}</div>
							</div>
							<div v-if="direction == 'buy'" class="mt-1">
								<span class="text-right">FX Buffer <span class="text-gold number-font">/5%</span></span>
								<div class="text-right float-right text-white number-font">Rp {{fxBufferEditShown}}</div>
							</div>

						</div>

						<div v-if="priceOzt15PercentAway" :class="`row alert alert-danger ${this.contractId_prop != this.$store.state.contractIds.contractId_100g ? 'bg-gold' : ''} mt-4 mb-0 mx-2 px-2 py-2`">
							<div class="col-auto" style="font-size: 2.2em;">&#9888;</div>
							<div class="col text-center pl-2">
								The price of this order is {{ Decimal.mul(minMaxLimitPrice, 100).toNumber() }}% away from current market price.
							</div>
						</div>
					</div>

				</div>

				<div class="row" :style="{display: displayFormOriginalOpen}">
					<div class="col-12">
						<div class="container rounded text-left value-field ">

							<div class="mb-3">
								<span class="text-left">Account</span>
								<div class="text-right float-right text-white">{{account}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Order ID</span>
								<div class="text-right float-right text-white">{{orderId}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Status</span>
								<div class="text-right float-right text-white text-uppercase">{{status}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Direction</span>
								<div class="text-right float-right text-uppercase font-weight-bold" :style="{color: (direction_prop == 'sell') ? 'red' : 'green'}">{{direction_prop}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Type</span>
								<div class="text-right float-right text-white text-uppercase">{{type}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Valid Until</span>
								<div class="text-right float-right text-white text-uppercase">{{validUntil}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Quantity</span>
								<div class="text-right float-right text-white">{{quantity}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Total Gram</span>
								<div class="text-right float-right text-white">{{totalGram}}</div>
							</div>
	
							<div class="mb-3">
								<span class="text-left">Price Per Gram</span>
								<div class="text-right float-right text-white">{{ (currency == 'idr')? 'Rp' : '$' }} {{numberFormat(pricePerGram)}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Contract Price</span>
								<div class="text-right float-right text-white">{{ (currency == 'idr')? 'Rp' : '$' }} {{numberFormat(contractPrice)}}</div>
							</div>
		
							<div class="mb-3">
								<span class="text-left">Contract Value</span>
								<div class="text-right float-right text-white">{{ (currency == 'idr')? 'Rp' : '$' }} {{numberFormat(contractValueShown)}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Fee <span class="text-gold number-font">/1%</span></span>
								<div class="text-right float-right text-white number-font">{{ (currency == 'idr')? 'Rp' : '$' }} {{feeShown}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Tax <span class="text-gold number-font">/0.1%</span></span>
								<div class="text-right float-right text-white number-font">{{ (currency == 'idr')? 'Rp' : '$' }} {{taxShown}}</div>
							</div>

							<div>
								<span class="text-left" style="font-size: 16px;">Total</span>
								<div class="text-right float-right number-font total-value">$ {{totalUsdLimitInInput}}</div>
								<div class="text-right number-font total-value total-value-idr mt-1">Rp {{totalIdrLimitInInput }}</div>
							</div>

							<div v-if="direction == 'buy'" class="mt-1">
								<span class="text-right">FX Buffer <span class="text-gold number-font">/5%</span></span>
								<div class="text-right float-right text-white number-font">Rp {{fxBufferShown}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row" :style="{display: displayFormOriginalFilled}">
					<div class="col-12">
						<div class="container rounded text-left value-field ">
							
							<div class="mb-3">
								<span class="text-left">Account</span>
								<div class="text-right float-right text-white">{{account}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Order ID</span>
								<div class="text-right float-right text-white">{{orderId}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Status</span>
								<div class="text-right float-right text-white text-uppercase">{{status}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Direction</span>
								<div class="text-right float-right text-uppercase font-weight-bold" :style="{color: (direction == 'sell') ? 'red' : 'green'}">{{direction}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Type</span>
								<div class="text-right float-right text-white text-uppercase">{{type}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Valid Until</span>
								<div class="text-right float-right text-white text-uppercase">{{validUntil}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Total Gram</span>
								<div class="text-right float-right text-white">{{numberFormat(totalGram)}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Quantity</span>
								<div class="text-right float-right text-white">{{quantity}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Fee</span>
								<div class="text-right float-right text-white">{{feeFilled}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Tax</span>
								<div class="text-right float-right text-white">{{taxFilled}}</div>
							</div>

							<div>
								<span class="text-left" style="font-size: 16px;">Total</span>
								<div class="text-right float-right number-font total-value">$ {{totalUsdFilled}}</div>
								<div class="text-right number-font total-value total-value-idr">Rp {{totalIdrFilled }}</div>
							</div>

						</div>
					</div>

				</div>

				<div class="row" :style="{display: displayFormOriginalKilled}">
					<div class="col-12">
						<div class="container rounded text-left value-field ">

							<div class="mb-3">
								<span class="text-left">Account</span>
								<div class="text-right float-right text-white">{{account}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Order Id</span>
								<div class="text-right float-right text-white">{{orderId}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Status</span>
								<div class="text-right float-right text-white text-uppercase">{{status}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Direction</span>
								<div class="text-right float-right text-uppercase font-weight-bold" :style="{color: (direction == 'sell') ? 'red' : 'green'}">{{direction}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Type</span>
								<div class="text-right float-right text-white text-uppercase">{{type}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Valid Until</span>
								<div class="text-right float-right text-white text-uppercase">{{validUntil}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Total Gram</span>
								<div class="text-right float-right text-white">{{numberFormat(totalGram)}}</div>
							</div>

							<div class="mb-3">
								<span class="text-left">Quantity</span>
								<div class="text-right float-right text-white">{{quantity}}</div>
							</div>

						</div>
					</div>
				</div>

				<hr>

				<div class="row px-2" :style="{display: displayEditRowButton}">
					<div class="col-6 pr-2">
						<button id="buttonCloseEditOrder" type="button" class="col btn btn-secondary " @click="cancelEditForm()">Cancel</button>

						<!-- <button id="buttonCloseTradeTicket" type="button" class="col btn c-btn-danger px-0 mr-3" data-dismiss="modal" @click="resetValue()">Close</button> -->
					</div>
					<div class="col-6 text-right pl-2">
						<button type="button" class="col btn c-btn-theme" @click="updateOrder()">Submit</button>
					</div>
				</div>

				<div class="row" :style="{display: displayOriginalRowButton}">
					<div class="col-6 text-left">
						<button id="buttonCloseDetailOrder" type="button" class="btn btn-sm btn-secondary" @click="closeModal()">Close</button>
					</div>
					<div v-if="this.$store.getters.getAccountLevel != 'ib' && this.$store.getters.getAccountLevel != 'fm' && this.$store.getters.getAccountLevel != 'ccp'" class="col-6 text-right">
						<button type="button" class="btn btn-sm btn-warning mr-2" :style="{ display: displayEdit }" @click="showEditForm()">Edit</button>
						<button type="button" class="btn btn-sm btn-danger" :style="{ display: displayKill }" @click="deleteOrder(orderId)">Kill</button>
					</div>
				</div>

			</div>
			<div v-else>
				<div class="row">
					<div class="col-12 text-center my-5">
						<Loader
							size_prop="10em"
						></Loader>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import Swal from 'sweetalert2'
	import {Decimal} from 'decimal.js'

	import Loader from '@/components/Loader.vue'
	export default {
		name: 'DetailOrder',
		props: {
			account_prop: {
				type: String,
				default: 'Account'
			},
			ticker_prop: {
				type: String,
				default: 'KAU_USD'
			},
			name: {
				type: String,
				default: 'Default'
			},
			orderId_prop: {
				type: String,
				default: ''
			},
			contractId_prop: {
				type: Number,
				default: -1
			},
			status_prop: {
				type: String,
				default: 'submit'
			},
			direction_prop: {
				type: String,
				default: 'buy'
			},
			type_prop: {
				type: String,
				default: 'limit'
			},
			validity_prop: {
				type: String,
				default: 'GTC'
			},
			validUntil_prop: {
				type: String,
				default: 'Until Cancel'
			},
			pricePerGram_prop: {
				type: Number,
				default: 0
			},
			totalGram_prop: {
				type: Number,
				default: 0
			},
			contractPrice_prop: {
				type: Number,
				default: 0
			},
			quantity_prop: {
				type: Number,
				default: 0
			},
			contractValue_prop: {
				type: Number,
				default: 0
			},
			modalOpen_prop: {
				type: Boolean,
				default: false
			},
			feeFilled_prop: {
				type: Number,
				default: -1,
			},
			taxFilled_prop: {
				type: Number,
				default: -1,
			},
			totalUsdFilled_prop: {
				type: Number,
				default: -1,
			}
		},
		components: {
			Loader
		},
		data() {
			return {
				Decimal: Decimal,
				formControl: false,
				formControlPlaintext: true,
				originalQuantity: 0,
				originalPricePerOzt: 0,
				originalContractPrice: 0,
				displayFormOriginal: 'flex',
				displayFormEdit: 'none',
				displayOriginalRowButton: 'flex',
				displayEditRowButton: 'none',
				varia: true,
				displayFormOriginalOpenValue: '-',
				displayFormOriginalFilledValue: '-',
				displayFormOriginalKilledValue: '-',
				limitOrderDate: '',
				limitOrderTime: '',

				quantityIntEdit: 0,
				quantityDecimalEdit: 0,

				pricePerGramEdit: 0,

				// minExpiryDateInInput:`${today.getFullYear()}-${today.getMonth() + 1 < 10 ? '0' : ''}${today.getMonth() + 1}-${today.getDate() + 1 < 10 ? '0' : ''}${today.getDate() + 1}`
			}
		},
		computed: {
			displayFormOriginalOpen: {
				get: function() {
					if (this.displayFormOriginalOpenValue == '-' && this.displayFormOriginalFilledValue == '-' && this.displayFormOriginalKilledValue == '-') {
						if (this.status_prop == 'submit') {
							return 'flex'
						}else {
							return 'none'
						}
					}else {
						return this.displayFormOriginalOpenValue
					}
				},
				set: function(value) {
					this.displayFormOriginalOpenValue = value
				},
			},
			displayFormOriginalFilled: {
				get: function() {
					if (this.displayFormOriginalOpenValue == '-' && this.displayFormOriginalFilledValue == '-' && this.displayFormOriginalKilledValue == '-') {
						if (this.status_prop == 'fill') {
							return 'flex'
						}else {
							return 'none'
						}
					}else {
						return this.displayFormOriginalFilledValue
					}
				},
				set: function(value) {
					this.displayFormOriginalFilledValue = value
				}
			},
			displayFormOriginalKilled: {
				get: function() {
					if (this.displayFormOriginalOpenValue == '-' && this.displayFormOriginalFilledValue == '-' && this.displayFormOriginalKilledValue == '-') {
						if (this.status_prop == 'cancel') {
							return 'flex'
						}else {
							return 'none'
						}
					}else {
						return this.displayFormOriginalKilledValue
					}
				},
				set: function(value) {
					this.displayFormOriginalKilledValue = value
				}
			},
			modalOpen() {
				return this.modalOpen_prop
			},
			modalClass() {
				return {
					modalDialog: true,
					'modal-open': true
				}
			},
			inputClass() {
				return {
					'form-control': this.formControl,
					'form-control-plaintext': this.formControlPlaintext,
					'form-control-sm': true,
					'px-2': true,
				}
			},

			currency() {
				return this.$store.state.currency
			},

			streamingRate() {
				return this.$store.getters.getStreamingRate
			},

			streamingRateBuy() {
				if (this.currency == 'idr') {
					return this.streamingRate.streamBuy
				}else {
					return 1
				}
			},

			streamingRateNow() {
				return (this.currency == 'idr') ? (this.direction == 'buy' ? this.streamingRate.streamBuy : this.streamingRate.streamSell) : 1
			},

			products() {
				return this.$store.getters.PRODUCTS
			},

			minMaxLimitPrice() {
				if (this.contractId_prop == this.$store.state.contractIds.contractId_100g) {
					return this.$store.state.minMaxLimitPriceKAU
				}
				return this.$store.state.minMaxLimitPriceIGX
			},

			sellPrice() {
				let gold = this.$store.getters.goldById(this.contractId_prop)
				if (gold) {
					if (gold.sell < 0 || gold.id == 0) {
						if (gold.buy < 0 || gold.id == 0) {
							return '-'
						}else {
							return gold.buy
						}
					}else {
						return gold.sell
					}
				}else {
					return '-'
				}
			},
			buyPrice() {
				let gold = this.$store.getters.goldById(this.contractId_prop)
				if (gold) {
					if (gold.buy < 0 || gold.id == 0) {
						if (gold.sell < 0 || gold.id == 0) {
							return '-'
						}else {
							return gold.sell
						}
					}else {
						return gold.buy
					}
				}else {
					return '-'
				}
			},

			weightCorrection() {
				let temp = this.products.find(obj => obj.attributes.contractId == this.contractId_prop)
				if (temp) {
					return temp.attributes.weightCorrection
				}else {
					return 1
				}
			},

			account() {
				return this.account_prop
			},
			orderId() {
				return this.orderId_prop
			},
			status() {
				if (this.status_prop == 'submit') {
					return 'submit'
				}else if (this.status_prop == 'fill') {
					return 'fill'
				}else {
					return 'cancel'
				}
			},
			direction() {
				return this.direction_prop
			},
			type() {
				return this.type_prop 
			},
			validUntil() {
				return this.validUntil_prop 
			},
			pricePerGram() {
				return Decimal.mul(this.pricePerGram_prop, this.streamingRateNow).toFixed(2)
			},
			totalGram() {
				return this.totalGram_prop
			},
			contractPrice() {
				return Decimal.mul(this.contractPrice_prop, this.streamingRateNow).toFixed(2)
			},
			quantity() {
				return this.quantity_prop 
			},

			contractValue() {
				return new Decimal(this.contractValue_prop).toFixed(2)
			},

			contractValueShown() {
				return Decimal.mul(this.contractValue, this.streamingRateNow).toFixed(2)
			},

			fee() {
				let temp = new Decimal(this.contractValue).div(100).toDecimalPlaces(2)
				if (temp.lessThan(this.$store.state.feeMin)) {
					return new Decimal(this.$store.state.feeMin)
				}
				return temp
			},
			feeShown() {
				let streamingRate = (this.currency == 'idr') ? (this.direction == 'buy' ? this.streamingRate.streamBuy : this.streamingRate.streamSell) : 1

				if (this.direction == 'buy') {
					return this.numberFormatExtend((this.fee).mul(streamingRate).toFixed(2))
				}else {
					return this.numberFormatExtend((this.fee).mul(streamingRate).toFixed(2))
				}
			},
			
			tax() {
				let temp = new Decimal(this.contractValue).div(1000).toDecimalPlaces(2)
				if (temp.lessThan(this.$store.state.taxMin)) {
					return new Decimal(this.$store.state.taxMin)
				}
				return temp
			},
			taxShown() {
				let streamingRate = (this.currency == 'idr') ? (this.direction == 'buy' ? this.streamingRate.streamBuy : this.streamingRate.streamSell) : 1

				if (this.direction == 'buy') {
					return this.numberFormatExtend((this.tax).mul(streamingRate).toFixed(2))
				}else {
					return this.numberFormatExtend((this.tax).mul(streamingRate).toFixed(2))
				}
			},

			fxBuffer() {
				let streamingRate = this.direction == 'buy' ? this.streamingRate.streamBuy : this.streamingRate.streamSell

				let temp = new Decimal(this.contractValue).mul(streamingRate).mul(5).div(100).toDecimalPlaces(2)
				if (temp.div(streamingRate).lessThan(0.01)) {
					return Decimal.mul(streamingRate, 0.01)
				}
				return temp
			},
			fxBufferShown() {
				if (this.direction == 'buy') {
					return this.numberFormat((this.fxBuffer).toFixed(2))
				}else {
					return this.numberFormat((this.fxBuffer).toFixed(2))
				}
			},

			totalUsdLimit() {
				let temp = new Decimal(this.contractValue)
				if (this.direction == 'buy') {
					temp = temp.plus(this.tax).plus(this.fee)
					return Number(temp.toFixed(2))
				}else {
					temp = temp.minus(this.tax).minus(this.fee)
					return Number(temp.toFixed(2))
				}
			},
			totalUsdLimitInInput() {
				if (this.direction == 'buy') {
					return this.numberFormatExtend(new Decimal(this.totalUsdLimit).toFixed(2))
				}else {
					return this.numberFormatExtend(new Decimal(this.totalUsdLimit).toFixed(2))
				}
			},

			totalIdrLimit() {
				let temp = new Decimal(this.totalUsdLimit)

				if (this.direction == 'buy') {
					return temp.times(this.streamingRate.streamBuy).plus(this.fxBuffer).toFixed(2)
				}else {
					return temp.times(this.streamingRate.streamSell).toFixed(2)
				}
			},
			totalIdrLimitInInput() {
				if (this.direction == 'buy') {
					return this.numberFormatExtend(new Decimal(this.totalIdrLimit).toFixed(2))
				}else {
					return this.numberFormatExtend(new Decimal(this.totalIdrLimit).toFixed(2))
				}
			},

			displayEdit() {
				let display = ''
				if (this.type_prop == 'limit' && this.status_prop == 'submit') {
					display = 'initial'
				}else {
					display = 'none'
				}
				return display
			},
			displayKill() {
				let display = ''
				if (this.status_prop == 'submit') {
					display = 'initial'
				}else {
					display = 'none'
				}
				return display
			},
			feeFilled() {
				return (this.feeFilled_prop).toFixed(2)
			},
			taxFilled() {
				return (this.taxFilled_prop).toFixed(2)
			},
			totalUsdFilled() {
				return this.numberFormat(((this.totalUsdFilled_prop-this.feeFilled)).toFixed(2))
			},
			totalIdrFilled() {
				return this.numberFormat(((this.totalUsdFilled_prop-this.feeFilled) * this.streamingRate.streamBuy).toFixed(2))
			},

			minExpiryDateInInput() {
				const dateNow = new Date()

				const day = dateNow.getDate() < 10 ? '0' + dateNow.getDate() : dateNow.getDate()
				const month = dateNow.getMonth() + 1 < 10 ? '0' + (dateNow.getMonth() + 1) : dateNow.getMonth() + 1
				const year = dateNow.getFullYear() < 10 ? '0' + dateNow.getFullYear() : dateNow.getFullYear()
				const hours = dateNow.getHours() < 10 ? '0' + dateNow.getHours() : dateNow.getHours()
				const minutes = dateNow.getMinutes() < 10 ? '0' + dateNow.getMinutes() : dateNow.getMinutes()

				const dateTemp = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
				
				return dateTemp
			},

			expiryDate() {
				// let dayMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu' ,'Fri' ,'Sat']
				// let monthMap = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
				let date
				if (this.validity_prop == 'GTC') {
					let tempToday = new Date(Date.now())
					date = new Date(tempToday.setDate(tempToday.getDate() + 30))
				}else {
					date = new Date(this.limitOrderDate)
				}
				// let time = this.limitOrderTime

				// let year = date.getFullYear()
				// let month = date.getMonth()
				// let day = date.getDay()

				// let dateTime =	`${date.getDate()} ${monthMap[date.getMonth()]} ${date.getFullYear()} 00:00:00 GMT+07:00`
				// let wow = new Date(dateTime)
				const year = date.getFullYear() < 10 ? '0' + date.getFullYear() : date.getFullYear()
				const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
				const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
				const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
				const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()

				return new Date(year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':00').toISOString()
			},

			quantityIntEditInInput: {
				get: function () {
					return this.quantityIntEdit
				},
				set: function (newValue) {
					let temp = Number(newValue)
					if (!Number.isInteger(temp)) {
						temp = Math.round(temp)
					}
					if (temp < 0) {
						this.quantityIntEdit = 0
					}else {
						this.quantityIntEdit = temp
					}
				}
			},
			quantityDecimalEditInInput: {
				get: function () {
					return this.quantityDecimalEdit
				},
				set: function (newValue) {
					let temp = new Decimal(newValue)
					if (temp.greaterThanOrEqualTo(1)) {
						this.quantityDecimalEdit = new Decimal(0.9)
					}else if (temp.lessThan(0)) {
						this.quantityDecimalEdit = new Decimal(0)
					}else {
						this.quantityDecimalEdit = new Decimal(temp.toFixed(1, Decimal.ROUND_DOWN))
					}
				}
			},
			quantityEdit() {
				return Decimal.add(this.quantityIntEdit, this.quantityDecimalEdit)
			},

			pricePerGramEditInInput: {
				get: function() {
					return this.pricePerGramEdit
				},
				set: function(newValue) {
					let temp = new Decimal(newValue)
					if (temp.lessThan(0)) {
						this.pricePerGramEdit = new Decimal(0)
					}
					else if (this.contractId_prop == this.$store.state.contractIds.contractId_10kg) {
						this.pricePerGramEdit = new Decimal(temp.toFixed(0))
					}
					else {
						this.pricePerGramEdit = new Decimal(temp.toFixed(2))
					}
				}
			},

			contractPriceEdit() {
				return this.numberFormat(Decimal.mul(Decimal.div(this.contractPrice_prop, this.pricePerGram_prop), this.pricePerGramEdit).toDecimalPlaces(2).mul(this.streamingRateNow).toFixed(2))
			},
			gram() {
				if (Decimal.mul(this.quantityEdit, this.$store.getters.contractConfigByContractId(this.contractId_prop).weightInGram).greaterThanOrEqualTo(0)) {
					return Decimal.mul(this.quantityEdit, this.$store.getters.contractConfigByContractId(this.contractId_prop).weightInGram)
				}else {
					return 0
				}
			},
			gramShown() {
				return this.numberFormatExtend(this.gram)
			},

			contractValueEdit() {
				let temp = (this.$store.getters.contractConfigByContractId(this.contractId_prop) || {}).weightInGram
				if (!temp) {
					return 0
				}
				temp = new Decimal(temp)

				let price = this.pricePerGramEdit

				if (price == '-') {
					return 0
				}else if (!(temp.equals(0.01))) {
					if (this.direction == 'buy') {
						return Decimal.mul(this.gram, price).toDecimalPlaces(2)
					}else {
						return Decimal.mul(this.gram, price).toDecimalPlaces(2)
					}
				}else {
					if (this.direction == 'buy') {
						return Decimal.mul(this.quantityEdit, price).toDecimalPlaces(2)
					}else {
						return Decimal.mul(this.quantityEdit, price).toDecimalPlaces(2)
					}
				}
			},
			contractValueEditShown() {
				let streamingRate = (this.currency == 'idr') ? (this.direction == 'buy' ? this.streamingRate.streamBuy : this.streamingRate.streamSell) : 1

				if (this.direction == 'buy') {
					return this.numberFormatExtend(new Decimal(this.contractValueEdit).mul(streamingRate).toFixed(2))
				}else {
					return this.numberFormatExtend(new Decimal(this.contractValueEdit).mul(streamingRate).toFixed(2))
				}
			},

			feeEdit() {
				let temp = new Decimal(this.contractValueEdit).div(100).toDecimalPlaces(2)
				if (temp.lessThan(this.$store.state.feeMin)) {
					return new Decimal(this.$store.state.feeMin)
				}
				return temp
			},
			feeEditShown() {
				let streamingRate = (this.currency == 'idr') ? (this.direction == 'buy' ? this.streamingRate.streamBuy : this.streamingRate.streamSell) : 1

				if (this.direction == 'buy') {
					return this.numberFormatExtend((this.feeEdit).mul(streamingRate).toFixed(2))
				}else {
					return this.numberFormatExtend((this.feeEdit).mul(streamingRate).toFixed(2))
				}
			},
			
			taxEdit() {
				let temp = new Decimal(this.contractValueEdit).div(1000).toDecimalPlaces(2)
				if (temp.lessThan(this.$store.state.taxMin)) {
					return new Decimal(this.$store.state.taxMin)
				}
				return temp
			},
			taxEditShown() {
				let streamingRate = (this.currency == 'idr') ? (this.direction == 'buy' ? this.streamingRate.streamBuy : this.streamingRate.streamSell) : 1

				if (this.direction == 'buy') {
					return this.numberFormatExtend((this.taxEdit).mul(streamingRate).toFixed(2))
				}else {
					return this.numberFormatExtend((this.taxEdit).mul(streamingRate).toFixed(2))
				}
			},

			fxBufferEdit() {
				let streamingRate = this.direction == 'buy' ? this.streamingRate.streamBuy : this.streamingRate.streamSell

				let temp = new Decimal(this.contractValueEdit).mul(streamingRate).mul(5).div(100).toDecimalPlaces(2)
				if (temp.div(streamingRate).lessThan(0.01)) {
					return Decimal.mul(streamingRate, 0.01)
				}
				return temp
			},
			fxBufferEditShown() {
				if (this.direction == 'buy') {
					return this.numberFormat((this.fxBufferEdit).toFixed(2))
				}else {
					return this.numberFormat((this.fxBufferEdit).toFixed(2))
				}
			},

			totalUsdLimitEdit() {
				let temp = new Decimal(this.contractValueEdit)
				if (this.direction == 'buy') {
					temp = temp.plus(this.taxEdit).plus(this.feeEdit)
				}else {
					temp = temp.minus(this.taxEdit).minus(this.feeEdit)
				}
				return Number(temp.toFixed(2))
				// return this.numberFormat((Decimal.div(this.contractPrice_prop, this.pricePerGram_prop).mul(this.pricePerGramEdit).mul(this.quantityEdit)).toFixed(2))
			},
			totalUsdLimitEditShown() {
				return this.numberFormatExtend(this.totalUsdLimitEdit)
			},

			totalIdrLimitEdit() {
				let temp = new Decimal(this.totalUsdLimitEdit)

				if (this.direction == 'buy') {
					return temp.times(this.streamingRate.streamBuy).plus(this.fxBufferEdit).toFixed(2)
				}else {
					return temp.times(this.streamingRate.streamSell).toFixed(2)
				}

				// return this.numberFormat((Decimal.div(this.contractPrice_prop, this.pricePerGram_prop).mul(this.pricePerGramEdit).mul(this.quantityEdit).mul(this.streamingRate.streamBuy)).toFixed(2))
			},
			totalIdrLimitEditShown() {
				return this.numberFormatExtend(this.totalIdrLimitEdit)
			},

			setDetailOrder_status() {
				return this.$store.state.setDetailOrder_status
			},

			priceOzt15PercentAway() {
				let price = '-'
				if (this.direction == 'buy') {
					price = this.buyPrice
				}else {
					price = this.sellPrice
				}
				if (price != '-') {
					price = new Decimal(price)
					let temp = new Decimal(this.pricePerGramEdit)

					if (temp.lessThanOrEqualTo(price.minus(price.times(this.minMaxLimitPrice))) || temp.greaterThanOrEqualTo(price.plus(price.times(this.minMaxLimitPrice)))) {
						return true
					}
				}
				return false
			},
		},

		watch: {
			quantity_prop(newValue) {
				this.quantityIntEdit = Math.floor(newValue)

				this.quantityDecimalEdit = Decimal.mod(newValue, 1)
				
				if (!this.$store.getters.contractConfigByContractId(this.contractId_prop).hasQuantityDecimal) {
					this.quantityDecimalEdit = 0
				}
			},
			pricePerGram_prop(newValue) {
				this.pricePerGramEdit = newValue
			},
			validUntil_prop(newValue) {
				this.limitOrderDate = `${newValue.substr(0, 4)}-${newValue.substr(5, 2)}-${newValue.substr(8, 2)} ${newValue.substr(11, 2)}:${newValue.substr(14, 2)}`
			},

			limitOrderDate(newValue) {
				const now = new Date()
				const expiryDate = new Date(newValue)
				
				const temp = new Date(now.setHours(now.getHours() + 1))

				if (expiryDate < temp) {
					const day = temp.getDate() < 10 ? '0' + temp.getDate() : temp.getDate()
					const month = temp.getMonth() + 1 < 10 ? '0' + (temp.getMonth() + 1) : temp.getMonth() + 1
					const year = temp.getFullYear() < 10 ? '0' + temp.getFullYear() : temp.getFullYear()
					const hours = temp.getHours() < 10 ? '0' + temp.getHours() : temp.getHours()
					const minutes = temp.getMinutes() < 10 ? '0' + temp.getMinutes() : temp.getMinutes()

					this.limitOrderDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
				}
			}
		},

		created() {
			this.limitOrderDate = `${this.validUntil_prop.substr(0, 4)}-${this.validUntil_prop.substr(5, 2)}-${this.validUntil_prop.substr(8, 2)} ${this.validUntil_prop.substr(11, 2)}:${this.validUntil_prop.substr(14, 2)}`
		},

		methods: {
			numberFormat(value) {
				let val = (value / 1)
				return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') //comma separator
			},
			showEditForm() {
				if (this.$store.state.marketStatus == 'close') {
					Swal.fire({
						background: '#191f31',
						title: '<span style="color: white;">The market is currently closed</span>',
						// html: '<span style="color: white;"></span>'
					})
				}else {
					this.limitOrderDate = `${this.validUntil_prop.substr(0, 4)}-${this.validUntil_prop.substr(5, 2)}-${this.validUntil_prop.substr(8, 2)} ${this.validUntil_prop.substr(11, 2)}:${this.validUntil_prop.substr(14, 2)}`
					// this.limitOrderTime = {hour: this.validUntil_prop.substr(11, 5)}

					this.displayFormEdit = 'flex'
					this.displayOriginalRowButton = 'none'
					this.displayEditRowButton = 'flex'

					this.displayFormOriginalOpen = 'none'
					this.displayFormOriginalFilled = 'none'
					this.displayFormOriginalKilled = 'none'
				}

			},
			cancelEditForm() {
				this.displayFormEdit = 'none'
				this.displayOriginalRowButton = 'flex'
				this.displayEditRowButton = 'none'

				if (this.status_prop == 'submit') {
					this.displayFormOriginalOpen = 'flex'
					this.displayFormOriginalFilled = 'none'
					this.displayFormOriginalKilled = 'none'
				}else if (this.status_prop == 'fill') {
					this.displayFormOriginalOpen = 'none'
					this.displayFormOriginalFilled = 'flex'
					this.displayFormOriginalKilled = 'none'
				}else {
					this.displayFormOriginalOpen = 'none'
					this.displayFormOriginalFilled = 'none'
					this.displayFormOriginalKilled = 'flex'
				}

				// this.quantityIntEdit = Math.floor(this.quantity_prop)
				// this.quantityDecimalEdit = 0
				this.pricePerGramEdit = this.pricePerGram_prop
			},

			increaseQuantityIntEdit() {
				let temp = Number(this.quantityIntEdit)
				temp += 1
				if (temp < 0) {
					this.quantityIntEdit = 0
				}else {
					this.quantityIntEdit = temp
				}
			},
			decreaseQuantityIntEdit() {
				let temp = Number(this.quantityIntEdit)
				temp -= 1
				if (temp < 0) {
					this.quantityIntEdit = 0
				}else {
					this.quantityIntEdit = temp
				}
			},
			increaseQuantityDecimalEdit() {
				let temp = new Decimal(this.quantityDecimalEdit)
				temp = temp.plus(0.1)
				if (temp.greaterThanOrEqualTo(1)) {
					this.quantityDecimalEdit = new Decimal(0.9)
				}else if (temp.lessThan(0)) {
					this.quantityDecimalEdit = new Decimal(0)
				}else {
					this.quantityDecimalEdit = temp
				}
			},
			decreaseQuantityDecimalEdit() {
				let temp = new Decimal(this.quantityDecimalEdit)
				temp = temp.sub(0.1)
				if (temp.greaterThanOrEqualTo(1)) {
					this.quantityDecimalEdit = new Decimal(0.9)
				}else if (temp.lessThan(0)) {
					this.quantityDecimalEdit = new Decimal(0)
				}else {
					this.quantityDecimalEdit = temp
				}
			},

			increasePricePerGramEdit() {
				let temp = new Decimal(this.pricePerGramEdit)
				if (this.contractId_prop == this.$store.state.contractIds.contractId_100g) {
					temp = temp.plus(0.01)
				}
				else if(this.contractId_prop == this.$store.state.contractIds.contractId_10kg) {
					temp = temp.plus(1)
				}
				else {
					temp = temp.plus(0.5)
				}

				if (temp < 0) {
					this.pricePerGramEdit = new Decimal(0)
				}else {
					this.pricePerGramEdit = temp
				}
			},
			decreasePricePerGramEdit() {
				let temp = new Decimal(this.pricePerGramEdit)
				if (this.contractId_prop == this.$store.state.contractIds.contractId_100g) {
					temp = temp.sub(0.01)
				}
				else if(this.contractId_prop == this.$store.state.contractIds.contractId_10kg) {
					temp = temp.sub(1)
				}
				else {
					temp = temp.sub(0.5)
				}

				if (temp.lessThan(0)) {
					this.pricePerGramEdit = new Decimal(0)
				}else {
					this.pricePerGramEdit = temp
				}
			},

			closeModal() {
				// this.varia = false
				this.displayFormOriginalOpen = '-'
				this.displayFormOriginalFilled = '-'
				this.displayFormOriginalKilled = '-'
				this.$emit('close')
			},

			deleteOrder() {
				let isError = false
				Swal.fire({
					background: '#191f31',
					title: '<span style="color: white;">Are you sure you wish to remove this order?</span>',
					html: "<span style='color: white;'>You won't be able to revert this!</span>",
					showCancelButton: true,
					confirmButtonText: 'Submit',
					showLoaderOnConfirm: true,
					preConfirm: () => {
						return axios({
							method: 'DELETE',
							url : process.env.VUE_APP_BACKEND_URL + '/demo-abx/trade/order/' + this.orderId,
						}).then(response => {

							console.log('berhasil delete order', response)
							Swal.fire({
								background: '#191f31',
								type: 'success',
								title: '<span style="color: white;">Deleted!</span>',
								html: '<span style="color: white;">Your order has been deleted.</span>',
							}).then((result) => {
								if (result.value) {
									this.closeModal()
									location.reload()
								}
							})
						}).catch(error => {
							isError = true

							if (error.response) {
								/*
								 * The request was made and the server responded with a
								 * status code that falls out of the range of 2xx
								 */
								console.log(error.response.data);
								console.log(error.response.status);
								console.log(error.response.headers);
							} else if (error.request) {
								/*
								 * The request was made but no response was received, `error.request`
								 * is an instance of XMLHttpRequest in the browser and an instance
								 * of http.ClientRequest in Node.js
								 */
								console.log(error.request);
							} else {
								// Something happened in setting up the request and triggered an Error
								console.log(error.message);
							}

							Swal.fire({
								background: '#191f31',
								type: 'error',
								title: '<span style="color: white;">Error boy!</span>',
								html: '<span style="color: white;">Error error error ha haha hahhahhahahah.</span>',
							})

							console.log('gagal delete order', error.config);
						})
					},
					allowOutsideClick: () => !Swal.isLoading()
				}).then((result) => {
					if (isError) {
						Swal.fire({
							background: '#191f31',
							type: 'error',
							title: '<span style="color: white;">Failed!</span>',
							// html: '<span style="color: white;">Your order has been updated</span>',
						}).then((result) => {
							if (result.value) {
								this.closeModal()
								location.reload()
							}
						})
					}else if (result.value) {
						Swal.fire({
							background: '#191f31',
							type: 'success',
							title: '<span style="color: white;">Success!</span>',
							html: '<span style="color: white;">Your order has been deleted</span>',
						}).then((result) => {
							if (result.value) {
								this.closeModal()
								location.reload()
							}
						})
					}
				})
			},
			updateOrder() {
				if (this.priceOzt15PercentAway && this.contractId_prop == this.$store.state.contractIds.contractId_100g) {
					Swal.fire({
						background: '#191f31',
						html: '<span style="color: white;">The price of this order is ' + this.numberFormat(Decimal.mul(this.minMaxLimitPrice, 100).toFixed(2)) + '% away from current market price.</span>'
					})

					return
				}
				// else if (this.priceOzt15PercentAway) {
				// 	Swal.fire({
				// 		background: '#191f31',
				// 		html: '<span style="color: white;">The price of this order is ' + this.numberFormat(Decimal.mul(this.$store.state.minMaxLimitPriceIGX, 100).toFixed(2)) + '% away from current market price.</span>'
				// 	})

				// 	return
				// }

				let isError = false
				Swal.fire({
					background: '#191f31',
					title: '<span style="color: white;">Are you sure want to update this order?</span>',
					showCancelButton: true,
					confirmButtonText: 'Submit',
					showLoaderOnConfirm: true,
					preConfirm: () => {
						return axios({
							method: 'PUT',
							url: process.env.VUE_APP_BACKEND_URL + '/demo-abx/trade/order/' + this.orderId_prop,
							data: {
								quantity: Number(Decimal.mul(this.quantityEdit, this.weightCorrection)),
								limitPrice: Number(Decimal.mul(this.pricePerGramEdit, Decimal.div(this.$store.getters.contractConfigByContractId(this.contractId_prop).weightMultiplication, this.weightCorrection))),
								// limit_price: 0,
								expiryDate: this.expiryDate,
								// direction: this.direction
							}
						}).then(response => {
							console.log('berhasil update order', response)
						}).catch(error => {
							isError = true
							console.log('Gagal update order', error.config)
							if (error.response) {
								/*
								 * The request was made and the server responded with a
								 * status code that falls out of the range of 2xx
								 */
								console.log(error.response.data)
								console.log(error.response.status)
								console.log(error.response.headers)
								return error.response
							} else if (error.request) {
								/*
								 * The request was made but no response was received, `error.request`
								 * is an instance of XMLHttpRequest in the browser and an instance
								 * of http.ClientRequest in Node.js
								 */
								console.log(error.request)
								return error.request
							} else {
								// Something happened in setting up the request and triggered an Error
								console.log(error.message)
								return error.message
							}
						})
					},
					allowOutsideClick: () => !Swal.isLoading()
				}).then((result) => {
					if (isError) {
						Swal.fire({
							background: '#191f31',
							type: 'error',
							title: '<span style="color: white;">Failed!</span>',
							// html: '<span style="color: white;">Your order has been updated</span>',
						}).then((result) => {
							if (result.value) {
								document.getElementById("buttonCloseEditOrder").click()
								this.closeModal()
								location.reload()
							}
						})
					}else if (result.value) {
						Swal.fire({
							background: '#191f31',
							type: 'success',
							title: '<span style="color: white;">Success!</span>',
							html: '<span style="color: white;">Your order has been updated</span>',
						}).then((result) => {
							if (result.value) {
								document.getElementById("buttonCloseEditOrder").click()
								this.closeModal()
								location.reload()
							}
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.modalDialog {
		position: fixed;
		font-family: Arial, Helvetica, sans-serif;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow-y: scroll;
		background: rgba(0,0,0,0.8);
		z-index: 1050;
		opacity:0;
		-webkit-transition: opacity 400ms ease-in;
		-moz-transition: opacity 400ms ease-in;
		transition: opacity 400ms ease-in;
		pointer-events: none;
	}.modalDialog:target {
		opacity:1;
		pointer-events: auto;
	}
	.modal-open {
		opacity: 1;
		pointer-events: auto;	
	}

	.modalDialog > div {
		max-width: 400px;
		position: relative;
		margin: 2% auto;
		padding: 5px 20px 13px 20px;
		border-radius: 5px;
		background: #25273A;
		background: -moz-linear-gradient(#fff, #999);
		background: -webkit-linear-gradient(#fff, #999);
		background: -o-linear-gradient(#fff, #999);
		color: rgba(255, 255, 255, 0.5);
	}
	.close {
		background: #606061;
		color: #FFFFFF;
		line-height: 25px;
		position: absolute;
		right: -12px;
		text-align: center;
		top: -10px;
		width: 24px;
		text-decoration: none;
		font-weight: bold;
		-webkit-border-radius: 12px;
		-moz-border-radius: 12px;
		border-radius: 12px;
		-moz-box-shadow: 1px 1px 3px #000;
		-webkit-box-shadow: 1px 1px 3px #000;
		box-shadow: 1px 1px 3px #000;
	}
	.close:hover { background: #00d9ff; }

	.c-prepend-button:hover {
		cursor: pointer;
	}
	.c-append-button:hover {
		cursor: pointer;
	}

	.form-control-plaintext {
		padding: 0px 1px 2.5px 1px;
	}

	input {
		text-transform: uppercase;
	}

	.c-select {
		padding-top: 1px;
		padding-bottom: 0px;
		padding-left: 5px;
		font-size: 12px;
	}

	input.c-disabled {
		color: rgb(255, 255, 255, 0.8);
	}

	.c-input-field {
	}

	.c-input {
		margin: 0 2px;
		padding: 0 8px;
		border: 2px solid #171721;
		background: transparent;
		height: 26.4px;
		border-radius: 4px;
		text-align: center;
		width: 93px;
		min-width: 80px;
	}

	.c-input:focus {
		border-color: gold;
		outline: none;
	}

	.button-counter {
		margin: 0;
		/*padding: 0;*/
		border: 0;
		height: 26.4px;
		width: 26.4px;
		background-color: #171721;
		color: gold;
		font-weight: bold;
		border-radius: 4px;
	}

	.button-counter:hover {
		cursor: pointer;
	}

	.button-counter:active {
		background-color: gold;
		color: #25273A;
	}

	.button-counter:focus {
		outline: 0;
	}

	.value-field {
		background-color: transparent;
	}

	.total-value {
		color: gold;
		font-size: 16px;
	}
	.total-value.total-value-idr{
		line-height: 16px;
	}

	.c-input.c-date-picker{
		position: relative;
		padding-left: 7px;
		padding-right: 6.5px;
		margin: 0;
		width: 180px;
		font-size: 12px;
		outline: 0;
		text-align: left;
		border: 0;
		background-color: #171721;
		cursor: text;
		color: white;
	}

	input[type="date"]::-webkit-calendar-picker-indicator {
		position: relative;
		margin-left: 0;
		right: -3.5px;
		color: transparent;
		background: none;
		z-index: 1;
		outline: 0;
		cursor: pointer;
	}

	input[type="date"]:before {
		color: white;
		background: none;
		display: block;
		content: '\0023CD';
		position: absolute;
		top: 0px;
		right: 7px;
		color: gold;
	}
</style>